import React, { useState } from "react";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import API_BASE_URL from '../config'; // কনফিগ থেকে বেজ ইউআরএল ইমপোর্ট করা হলো
import "./Home.css"; 

const Home = ({ setLoggedIn, language, handleLanguageChange }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    
    const [form, setForm] = useState({ username: "", password: "" });
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleLoginSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            // API_BASE_URL ব্যবহার করা হলো
            const response = await fetch(`${API_BASE_URL}/auth/login`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ username: form.username, password: form.password }),
            });
            const data = await response.json();
            if (response.ok && data.success) {
                localStorage.setItem('loggedIn', 'true');
                localStorage.setItem('userRole', data.role);
                localStorage.setItem('userName', data.username);
                setLoggedIn(true);
                navigate("/"); 
            } else {
                alert(data.message || t("invalid_credentials"));
            }
        } catch (err) {
            alert(t("server_error") || "Server error.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="hp-container">
            <div className="hp-hero-section">
                <div className="hp-hero-content">
                    <img src="/static/n-tools.png" alt="logo" className="hp-logo-img" />
                    
                    <h1 className="hp-title">
                        {t('welcome_title')} {t('diagnostics_tools')}
                    </h1>
                    
                    <h2 className="hp-sub-brand">
                        <a 
                            href="https://n-tools.info" 
                            target="_blank" 
                            rel="noopener noreferrer" 
                            className="hp-domain-link"
                        >
                            n-tools.info
                        </a>
                    </h2>
                    
                    <p className="hp-slogan">
                        "{t('slogan')}"
                    </p>

                    <div className="hp-features">
                        <p>✓ {t('feat_fast_diag')}</p>
                        <p>✓ {t('feat_realtime')}</p>
                        <p>✓ {t('feat_logging')}</p>
                    </div>

                    <div className="hp-footer-text">
                        &copy; by Neamol Haq
                    </div>
                </div>
            </div>

            <div className="hp-login-wrapper">
                <div className="login-card">
                    <form onSubmit={handleLoginSubmit} className="login-main-form">
                        <h2 className="login-title">{t('login')}</h2>
                        
                        <div className="login-input-group">
                            <input
                                type="text"
                                className="login-input-field"
                                placeholder={t('username')}
                                required
                                value={form.username}
                                onChange={(e) => setForm({ ...form, username: e.target.value })}
                            />
                        </div>

                        <div className="login-input-group login-password-wrapper">
                            <input
                                type={showPassword ? "text" : "password"}
                                className="login-input-field"
                                placeholder={t('password')}
                                required
                                value={form.password}
                                onChange={(e) => setForm({ ...form, password: e.target.value })}
                            />
                            <span className="login-password-toggle" onClick={() => setShowPassword(!showPassword)}>
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </span>
                        </div>

                        {/* Forgot Password Link */}
                        <div style={{ textAlign: 'right', marginBottom: '15px' }}>
                            <span 
                                onClick={() => navigate('/forgot-password')} 
                                style={{ color: '#764ba2', fontSize: '13px', cursor: 'pointer', fontWeight: '600' }}
                            >
                                Forgot Password?
                            </span>
                        </div>

                        <div className="login-button-container">
                            <button type="submit" className="login-btn-primary" disabled={loading}>
                                {loading ? '...' : t('submit')}
                            </button>
                            <button type="button" className="login-btn-secondary" onClick={() => navigate('/register')}>
                                {t('self_registration')}
                            </button>
                        </div>

                        <div className="login-lang-section">
                            <select value={language} onChange={handleLanguageChange} className="login-lang-select">
                                <option value="en">English</option>
                                <option value="bn">বাংলা</option>
                            </select>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Home;